import { useState, useEffect } from 'react';
import { APP_SETTINGS } from './useAppSettings';

export const useController = () => {
  const [url, setUrl] = useState('');
  const [data, setData] = useState(null);
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const fetchData = async (url) => {
    setIsLoading(true);
    try {
      const responseIn = await fetch(url);
      await setResponse(responseIn);
      if (!response.ok) {
        const result = await response.json();
        throw new Error(result?.Message);
      }
      const result = await response.json();
      setData(result);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDataAuth = async (url, token) => {
    setIsLoading(true);
    try {
      var options = {
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + token,
        },
      };
      const responseIn = await fetch(url,options);
     
      if (!responseIn?.ok) {
        await setResponse(responseIn);
        const result = await responseIn.json();
        throw new Error(result?.Message);
      }
      const result = await responseIn.json();
      setData(result);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }
  
  const postData = async (url) => {
    setIsLoading(true);
    try {
      const headersIn = { "Content-Type": "application/x-www-form-urlencoded",
}
      const responseIn = await fetch(url,{method:'POST', headers: headersIn});
      await setResponse(responseIn);
      if (!responseIn.ok) {
        const result = await responseIn.json();
        throw new Error(result?.Message);
      }
      const result = await responseIn.json();
      setData(result);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const postDataAuth = async (url, token) => {
    setIsLoading(true);
    try {
      const headersIn = { "Content-Type": "application/json",
      Authorization: "Bearer " + token,
}
      const responseIn = await fetch(url,{method:'POST', headers: headersIn});
      await setResponse(responseIn);
      if (!responseIn.ok) {
        const result = await responseIn.json();
        throw new Error(result?.Message);
      }
      const result = await responseIn.json();
      setData(result);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const login =  async (email, password)=> {
    setIsLoading(true);
    try {
      var options = {
        headers:{
          "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "POST",
        body: "grant_type=password&Username=" + email + "&password=" + password,
      };
      var url = `${APP_SETTINGS?.url}/Login`;
      const responseIn = await fetch(url,options);
      await setResponse(responseIn);
      if (!responseIn?.ok) {
        const result = await responseIn.json();
        throw new Error(result?.error_description);
      }
      const result = await responseIn.json();
      setData(result);
    } catch (error) {
      setError(data?.error_description);
    } finally {
      setIsLoading(false);
    }
  };

  
  
  useEffect(() => {
    if (url) {
      fetchData();
    }
  }, [url]);

  return { data, isLoading, response, error, setUrl, fetchData, postDataAuth, fetchDataAuth, postData, login };
};
